import { fetchEndpoint } from '../server/network'

// 首页推荐商品列表
export const homeProductList = () => fetchEndpoint('/v2/ecapi.home.product.list')

// 首页 banner
export const homeBanner = () => fetchEndpoint('/v2/ecapi.banner.list')

// 推荐商品
export const geStochastic = (data) => fetchEndpoint('/v2/ecapi.stochastic.list', 'post', data)

// 商品列表
export const productList = (data) => fetchEndpoint('/v2/ecapi.product.list', 'POST', data)

// 商品详情
export const productGet = (data) => fetchEndpoint('/v2/ecapi.product.get', 'POST', data)

// 商品问答
export const answerGet = (data) => fetchEndpoint('/v2/ecapi.answer.get', 'POST', { product: data })

// 添加问题
export const issue = (data) => fetchEndpoint('/v2/ecapi.answer.issue', 'POST', data)

// 文献
export const zhiLiaoWo = (data) => fetchEndpoint('/v2/ecapi.zhiliaowo.get', 'POST', data)

// 产品分类
export const categoryList = (data) => fetchEndpoint('/v2/ecapi.category.list', 'POST', data)

// 活动列表
export const activityProduct = (data) => fetchEndpoint('/v2/ecapi.activity.product', 'POST', data)

// 活动分类（每日特价/限时特惠）
export const special = (data) => fetchEndpoint('/v2/ecapi.special.get', 'POST', data)

// 活动分类类型
export const activityTypes = () => fetchEndpoint('/v2/ecapi.activity.types', 'POST')

// 收藏
export const collect = (data) => fetchEndpoint('/v2/ecapi.collect.get', 'POST', data)

// 已收藏的商品列表
export const productLikedList = (data) => fetchEndpoint('/v2/ecapi.product.liked.list', 'POST', data)



// WEBPACK FOOTER //
// ./src/api/product.js